const autorikshaw_right = require('../imgs/vehicles/autorikshaw_right.png');
const auto_rear_celebrate = require('../imgs/vehicles/auto_rear_celebrate.png');
const autorikshaw_top = require('../imgs/vehicles/auto_topview.png');
const autorikshaw_front = require('../imgs/vehicles/auto_front.png');
const bike_right = require('../imgs/vehicles/bike_right.png');
const car_right = require('../imgs/vehicles/car_right.png');
const car_top = require('../imgs/vehicles/car_top.png');
const bike_top = require('../imgs/vehicles/bike_right.png');
const iconNoImage=require('../imgs/noImage.png')



//Payments, Payment Methods
const cash = require('../imgs/payments/Cash.png')
const phonepe = require('../imgs/payments/PhonePe.png');
const phonepe_r = require('../imgs/payments/PhonePe_r.png');
const googlepay = require('../imgs/payments/Gpay.png');
const googlepay_r = require('../imgs/payments/Gpay_r.png');
const paytm = require('../imgs/payments/Paytm.png');
const currency = require('../imgs/payments/currency.png');
const UPI = require('../imgs/payments/UPI.png');
const card = require('../imgs/payments/Card.png');
const success = require('../imgs/payments/success.png');
const failure = require('../imgs/payments/failure.png');


export const driverDummyImage=require('../imgs/dummyDriver.png')

export const getImageByService = (service) => {

    switch (service) {
      case 'AUTO':
        return autorikshaw_right;
      case 'AUTO_TOP':
        return autorikshaw_top;
      case 'BIKE':
        return bike_right;
      case 'CAR':
        return car_right;
      case 'CAR_TOP':
        return car_top;
      default:
        return iconNoImage;
    }
  
  };

  export const getImageByPaymentMethod = (paymentMethod) => {

    switch (paymentMethod) {
      case 'CASH':
        return cash;
      case 'PHONE_PE':
        return phonepe;
      case 'GOOGLE_PAY':
        return googlepay;
      case 'PHONE_PE_R':
        return phonepe_r;
      case 'GOOGLE_PAY_R':
        return googlepay_r;
      case 'PAYTM':
        return paytm;
      case 'CURRENCY':
        return currency;
      case 'UPI':
        return UPI;
      case 'CARD':
        return card;
      case 'SUCCESS':
        return success;
      case 'FAILURE':
        return failure;
      default:
        return cash;
    }
  };